var map = {
	"./cover-page.jpg": "./src/EGRContent/Story/SashiKoGhum/images/cover-page.jpg",
	"./cover_banner.png": "./src/EGRContent/Story/SashiKoGhum/images/cover_banner.png",
	"./ghum.gif": "./src/EGRContent/Story/SashiKoGhum/images/ghum.gif",
	"./ghum.png": "./src/EGRContent/Story/SashiKoGhum/images/ghum.png",
	"./last_page.jpg": "./src/EGRContent/Story/SashiKoGhum/images/last_page.jpg",
	"./page01.jpg": "./src/EGRContent/Story/SashiKoGhum/images/page01.jpg",
	"./page02.jpg": "./src/EGRContent/Story/SashiKoGhum/images/page02.jpg",
	"./page03_back.png": "./src/EGRContent/Story/SashiKoGhum/images/page03_back.png",
	"./page03_front.png": "./src/EGRContent/Story/SashiKoGhum/images/page03_front.png",
	"./page04_back.png": "./src/EGRContent/Story/SashiKoGhum/images/page04_back.png",
	"./page04_front.png": "./src/EGRContent/Story/SashiKoGhum/images/page04_front.png",
	"./page05_and06_back.png": "./src/EGRContent/Story/SashiKoGhum/images/page05_and06_back.png",
	"./page05_and06_back_new.jpg": "./src/EGRContent/Story/SashiKoGhum/images/page05_and06_back_new.jpg",
	"./page05_front.gif": "./src/EGRContent/Story/SashiKoGhum/images/page05_front.gif",
	"./page05_front.png": "./src/EGRContent/Story/SashiKoGhum/images/page05_front.png",
	"./page06_front.gif": "./src/EGRContent/Story/SashiKoGhum/images/page06_front.gif",
	"./page06_front.png": "./src/EGRContent/Story/SashiKoGhum/images/page06_front.png",
	"./page07.jpg": "./src/EGRContent/Story/SashiKoGhum/images/page07.jpg",
	"./page08.jpg": "./src/EGRContent/Story/SashiKoGhum/images/page08.jpg",
	"./page09.jpg": "./src/EGRContent/Story/SashiKoGhum/images/page09.jpg",
	"./page09_front.gif": "./src/EGRContent/Story/SashiKoGhum/images/page09_front.gif",
	"./page09_front.png": "./src/EGRContent/Story/SashiKoGhum/images/page09_front.png",
	"./page09_front_with_bg.gif": "./src/EGRContent/Story/SashiKoGhum/images/page09_front_with_bg.gif",
	"./page10.jpg": "./src/EGRContent/Story/SashiKoGhum/images/page10.jpg",
	"./page10_new.jpg": "./src/EGRContent/Story/SashiKoGhum/images/page10_new.jpg",
	"./page11.jpg": "./src/EGRContent/Story/SashiKoGhum/images/page11.jpg",
	"./rain_drop.gif": "./src/EGRContent/Story/SashiKoGhum/images/rain_drop.gif",
	"./raining.gif": "./src/EGRContent/Story/SashiKoGhum/images/raining.gif",
	"./raining_new.png": "./src/EGRContent/Story/SashiKoGhum/images/raining_new.png",
	"./story-banner.svg": "./src/EGRContent/Story/SashiKoGhum/images/story-banner.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/EGRContent/Story/SashiKoGhum/images sync recursive ^\\.\\/.*$";